import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalRuleDetail  {
    _originalTypeClassName = "zERP.BO.GeneralJournalRuleDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalRuleDetail.translate = translateService;
}
this.CollectionItems = [];
this.Conditions = [];
this.GeneralJournalRuleDetailID = null;
this.Description = null;
this.DebitField = null;
this.CreditField = null;
this._key = this.GeneralJournalRuleDetailID = 0; 
}

static translate: TranslateService;
_key: any;
private _GeneralJournalRuleDetailID:any;
get GeneralJournalRuleDetailID(): any {
    return this._GeneralJournalRuleDetailID;
  }
set GeneralJournalRuleDetailID(value: any) {
    this._GeneralJournalRuleDetailID = value;
    this._key = value;
  }
Description:any;
DebitField:any;
CreditField:any;
ChartOfAccount_Category:any;
CollectionItems:any;
Conditions:any;
AccountLocator:any;
static setChartOfAccount_Category = ($this, value) => {
var oldValue = $this.ChartOfAccount_Category;
$this.ChartOfAccount_Category = value;
if (value != null) {
}
}
static setCollectionItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.CollectionItems == null) $this.CollectionItems = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CollectionItems.length > 0) {
                    Domain.GeneralJournalRuleDetail.removeCollectionItems($this, $this.CollectionItems[0]);
                }

                Domain.GeneralJournalRuleDetail.addManyCollectionItems($this, copyItems);
            }
static addManyCollectionItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalRuleDetail.addCollectionItems($this, items[i]);
                }
            }
static addCollectionItems = ($this, item) => {
                if ($this.CollectionItems == null) $this.CollectionItems = [];
                if (item == null || $this.CollectionItems.indexOf(item) > -1) return;
                $this.CollectionItems.push(item);
}
static addRangeCollectionItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalRuleDetail.addCollectionItems($this, item));
            }
static removeCollectionItems = ($this, item) => {
                if ($this == null || $this.CollectionItems == null || $this.CollectionItems.indexOf(item) === -1) return;
                var _index = $this.CollectionItems.indexOf(item);
                $this.CollectionItems.splice(_index, 1);
}
static clearCollectionItems = ($this) => { $this.CollectionItems = null; }
static setConditions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Conditions == null) $this.Conditions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Conditions.length > 0) {
                    Domain.GeneralJournalRuleDetail.removeConditions($this, $this.Conditions[0]);
                }

                Domain.GeneralJournalRuleDetail.addManyConditions($this, copyItems);
            }
static addManyConditions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalRuleDetail.addConditions($this, items[i]);
                }
            }
static addConditions = ($this, item) => {
                if ($this.Conditions == null) $this.Conditions = [];
                if (item == null || $this.Conditions.indexOf(item) > -1) return;
                $this.Conditions.push(item);
}
static addRangeConditions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalRuleDetail.addConditions($this, item));
            }
static removeConditions = ($this, item) => {
                if ($this == null || $this.Conditions == null || $this.Conditions.indexOf(item) === -1) return;
                var _index = $this.Conditions.indexOf(item);
                $this.Conditions.splice(_index, 1);
}
static clearConditions = ($this) => { $this.Conditions = null; }
static setAccountLocator = ($this, value) => {
var oldValue = $this.AccountLocator;
$this.AccountLocator = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GeneralJournalRuleDetailID == null || $this.GeneralJournalRuleDetailID == 0;
            }


}